module.exports = __webpack_public_path__ + "media/images/viessmann_banner/banner__sidebar-3490f0f22a61052a871b1e75d62e666d.png";